module.exports = __webpack_public_path__ + "static/media/activity_type_creatief.9d33ce7b.svg";